import { GiftCardGenerateRequestDto } from './giftCardGenerateRequest.dto';
import { MerchantDto } from '../merchant.dto';
import { IsEmail, IsNotEmptyObject } from 'class-validator';

export class GiftCardBackofficeGenerateRequestDto extends GiftCardGenerateRequestDto {
  @IsEmail()
  userEmail: string;
  @IsNotEmptyObject()
  currentMerchant: MerchantDto;
}
